import PropTypes from "prop-types";
import React from "react";
import {Link} from "react-router-dom";

import {AppRoute} from "../const";


export const BackButton = (props) => {
  const {
    activePeriodId
  } = props;

  const searchRequest = activePeriodId ? `?period=${activePeriodId}` : ``;

  return (
    <Link
      className="back-button"
      to={{
        pathname: AppRoute.MAIN,
        search: searchRequest,
      }}
    >
      <span className="back-button__icon  icon-arrow-left"></span>
      <span className="visually-hidden">Назад</span>
    </Link>
  );
};


BackButton.propTypes = {
  activePeriodId: PropTypes.string.isRequired,
};
